import React, { Component } from 'react'

import {
  BrowserRouter as Router,
  Route
} from "react-router-dom";

import { connect } from 'react-redux';
import * as actions from './Actions';

import PrivateRoute from "./components/PrivateRoute";

import './main.css';

import Header from "./containers/Header/Header";
import Logout from './containers/Header/Logout';
import Home from "./Home";
import Load from "./modules/user/Load";
import Memories from "./modules/memories/Memories";
import Notes from "./modules/notes/Notes";


export class MainApp extends Component {
    state = {
        loading: true
    };

    componentDidMount() {

        this.setState({ loading: false })

    }


    onLogout = () => {
        console.log('onLogout')
        this.header.logout()
     }


    render() {

        const { loading } = this.state;

        if(loading) { // if your component doesn't have to wait for an async action, remove this block
          return null; // render null when app is not ready
        }

        return (
            <div className="App">

                <Router>
                <div>

                    <Header onRef={ref => (this.header = ref)} />

                    <Route exact path="/" component={Home} />
                    <Route exact path="/me/logout" component={Logout}  />
                    <PrivateRoute auth={this.props.auth.user.id} redirect={"/"} path="/me/load" component={Load} />
                    <PrivateRoute auth={this.props.auth.user.id} redirect={"/"} path="/me/memories" component={Memories} />

                    <PrivateRoute auth={this.props.auth.user.id} redirect={"/"} path="/me/notes" component={Notes} />

                    {/*<button onClick={this.onLogout}>Salir</button>*/}

                </div>
                </Router>

            </div>
        )
    }

};


const mapStateToProps = (state) => ({
    text: state.text_reducer.text,
    auth: state.auth_reducer
});

export default connect(mapStateToProps, actions)(MainApp);



// WEBPACK FOOTER //
// ./src/MainApp.js